import React, { Fragment } from 'react';
import DOMPurify from 'utils/sanitize';
import '../less/main.less';

export default function template() {
  const { children, tabs, tab, toggle } = this.props;

  const btns = tabs.map(item => {
    const isSelected = tab === item.tab ? ' vertical-tabs__btn_selected' : '';

    return (
      <Fragment key={item.tab}>
        <button
          className={`vertical-tabs__btn${isSelected}`}
          onClick={() => toggle(item.tab)}
          dangerouslySetInnerHTML={{
            __html: DOMPurify.sanitize(this.l10n(item.name)),
          }}
        />
      </Fragment>
    );
  });

  const renderedChildren = children
    ? children.map((item, index) => {
        const tabValue = tabs[index].tab;
        return (
          <div
            key={tabValue}
            className="vertical-tabs__content"
            style={{ display: tab === tabValue ? 'block' : 'none' }}
          >
            {item}
          </div>
        );
      })
    : null;

  return (
    <div className="vertical-tabs">
      <div className="container">
        <div className="vertical-tabs__body">
          <div className="vertical-tabs__left">{btns}</div>
          {renderedChildren}
        </div>
      </div>
    </div>
  );
}
